import {ConversationLogItemMessageAdded} from '@stripe-internal/conversations-client';
import {NamedAvatar, StripeAvatar} from '../../../Chat';

export const avatarForMessage = (item: ConversationLogItemMessageAdded) => {
  const {participant} = item.message;

  let avatar = null;
  if (participant.role === 'agent') {
    avatar = <NamedAvatar name={participant.displayName} />;
  } else if (participant.role === 'bot') {
    avatar = <StripeAvatar />;
  }

  return avatar;
};
